document.addEventListener("DOMContentLoaded", function () {
  const localeMap = {
    US: 'en-US',
    AU: 'en-AU',
    CA: 'en-CA',
    DK: 'da-DK',
    DE: 'de-DE',
    IE: 'en-IE',
    IT: 'it-IT',
    NL: 'nl-NL',
    ES: 'es-ES',
    GB: 'en-GB'
  };

  const carrierLogos = {
    "Royal Mail": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/rmg_logo.svg?v=1744747297",
    "An Post": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/An_Post.png?v=1744747160",
    "PostNord": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/postnord_DK.webp?v=1744747159",
    "USPS": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/USPS.svg?v=1744747159",
    "Canada Post": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/Canada_Post.svg?v=1744747159",
    "PostNL": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/PostNL.svg?v=1744747159",
    "SDA Poste Italiane": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/SDA.svg?v=1744747159",
    "DPD": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/DPD.svg?v=1744747159",
    "Australia Post": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/Australia_Post.svg?v=1744747159",
    "UPS": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/UPS.svg?v=1744747159",
    "DHL": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/DHL.svg?v=1744747159",
    "Correos": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/Correos.svg?v=1744747159",
    "Poste Italiane": "https://cdn.shopify.com/s/files/1/0657/5138/4294/files/SDA.svg?v=1744747159",
  };
  
const shippingData = {
  US: { flag: "🇺🇸", text: "Courier", carriers: ["USPS", "UPS"], label: "Ships by" },
  AU: { flag: "🇦🇺", text: "Courier", carriers: ["Australia Post"], label: "Ships by" },
  CA: { flag: "🇨🇦", text: "Courier", carriers: ["Canada Post"], label: "Ships by" },
  DK: { flag: "🇩🇰", text: "Kurér", carriers: ["PostNord"], label: "Afsendes senest" },
  DE: { flag: "🇩🇪", text: "Kurier", carriers: ["DHL"], label: "Versand bis" },
  IE: { flag: "🇮🇪", text: "Courier", carriers: ["An Post", "DPD"], label: "Ships by" },
  IT: { flag: "🇮🇹", text: "Corriere", carriers: ["Poste Italiane"], label: "Spedizione entro" },
  NL: { flag: "🇳🇱", text: "Koerier", carriers: ["PostNL", "DHL"], label: "Verzending uiterlijk" },
  ES: { flag: "🇪🇸", text: "Mensajería", carriers: ["Correos"], label: "Se envía antes del" },
  GB: { flag: "🇬🇧", text: "Courier", carriers: ["Royal Mail", "DPD"], label: "Ships by" }
};

  const container = document.querySelector(".custom-shipping-container");
  if (!container) return;

  const div = document.getElementById("shipping-message");
  const countryCode = container.dataset.customerCountry;

  const today = new Date();
  today.setDate(today.getDate() + 2);
  const options = { weekday: "short", month: "short", day: "numeric" };
  const locale = localeMap[countryCode] || navigator.language || 'en-US';
  const formattedDate = today.toLocaleDateString(locale, options);

  const data = shippingData[countryCode];

  if (data) {
    const carriersHtml = data.carriers.map(name => {
      const logo = carrierLogos[name];
      const logoImg = logo ? `<div class="carrier-logo-img"><img src="${logo}" alt="${name}" title="${name}"></div>` : "";
      return `<div class="carrier-item">${logoImg}</div>`;
    }).join(`${'&nbsp;'}/${'&nbsp;'}`);

    div.innerHTML = `
      <div class="shipping__wrapper">
        <div class="shipping__delivery_date">${data.label} <strong>${formattedDate}</strong></div>
        <div class="shipping__delivery_options">${data.flag}&nbsp;${data.text}&nbsp;${carriersHtml}</div>
      </div>`;
  } else {
    div.innerHTML = `<div class="shipping__wrapper">🌍 Worldwide Shipping – Estimated in 10–15 days.</div>`;
  }
});
